import Vue from 'vue'
import router from '@/router/index'
import * as Sentry from '@sentry/vue'
import { BrowserTracing } from '@sentry/tracing'

if (!+process.env.VUE_APP_LOCAL_ENV) {
  Sentry.init({
    Vue,
    dsn:
      'https://f4ad4e7a65d341ceb8624c91d6812035@o614951.ingest.sentry.io/5749800',
    integrations: [
      new BrowserTracing({
        routingInstrumentation: Sentry.vueRouterInstrumentation(router),
      }),
    ],
    environment:
      process.env.NODE_ENV === 'production' ? 'production' : 'development',
    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // tracesSampleRate: 0.5,
    tracesSampleRate: 0.25,
    // attachProps:false
    release: 'minimart@' + process.env.VUE_APP_MM_VERSION,
  })
}
